import { useNavigate } from 'react-router-dom';
import HeroSection from '@/components/landing/HeroSection';
import PainPointsSection from '@/components/landing/PainPointsSection';
import SolutionSection from '@/components/landing/SolutionSection';
import CoupleSection from '@/components/landing/CoupleSection';
import HowItWorks from '@/components/landing/HowItWorks';
import PricingSection from '@/components/landing/PricingSection';
import FinalCta from '@/components/landing/FinalCta';
import LandingNav from '@/components/landing/LandingNav';
import Footer from '@/components/landing/Footer';

export default function Landing() {
  const navigate = useNavigate();

  const goToApp = () => navigate('/auth/register');

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950">
      <LandingNav onCta={goToApp} />
      <HeroSection onCta={goToApp} />
      <PainPointsSection />
      <SolutionSection />
      <CoupleSection onCta={goToApp} />
      <HowItWorks />
      <PricingSection onCta={goToApp} />
      <FinalCta onCta={goToApp} />
      <Footer />
    </div>
  );
}
